// extracted by mini-css-extract-plugin
export default {"livevideo":"Live_livevideo__9ailg"};